import React, { Fragment } from "react";
export const KeyValUnderline = ({ title, value, titleOnly, valueStyles = {}, titleStyles = {}, containerStyles = {} }) => {
  return (
    <div className="key-val-underline" style={containerStyles}>
      {titleOnly ? (
        <div className="title" style={titleStyles}>
          {title !== "" ? `${title}` : title}
        </div>
      ) : (
        <Fragment>
          <div className="title" style={titleStyles}>
            {title !== "" ? `${title}:` : title}
          </div>
          <div className="value" style={valueStyles}>
            {value}
          </div>
        </Fragment>
      )}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/libraries/ReportGenerator/KeyValUnderline.jsx